// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-debug-info {
  width: 500px;
  margin-top: 20px;
  color: var(--g-color-text-hint);
}
.error-debug-info__copy-btn {
  margin-left: 10px;
}
.error-debug-info_mobile {
  display: flex;
  width: auto;
  flex-direction: column-reverse;
  align-items: center;
  margin-bottom: 12px;
}
.error-debug-info_mobile .error-debug-info__copy-btn {
  color: var(--g-color-text-primary);
  margin-left: 0;
  margin-bottom: 12px;
}
.error-debug-info_mobile .error-debug-info__copy-id {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ErrorContent/DebugInfo/DebugInfo.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,YAAA;EACA,gBAAA;EACA,+BAAA;AAFJ;AAII;EACI,iBAAA;AAFR;AAKI;EACI,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,kCAAA;EACA,cAAA;EACA,mBAAA;AAHZ;AAMQ;ECqJJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADxJJ","sourcesContent":[".error-debug-info {\n  width: 500px;\n  margin-top: 20px;\n  color: var(--g-color-text-hint);\n}\n.error-debug-info__copy-btn {\n  margin-left: 10px;\n}\n.error-debug-info_mobile {\n  display: flex;\n  width: auto;\n  flex-direction: column-reverse;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.error-debug-info_mobile .error-debug-info__copy-btn {\n  color: var(--g-color-text-primary);\n  margin-left: 0;\n  margin-bottom: 12px;\n}\n.error-debug-info_mobile .error-debug-info__copy-id {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
